/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Where an authentication credential is transmitted in the HTTP request.
 */
export type AuthLocation = 'Header' | 'Query' | 'Cookie';

export const AuthLocation = {
  Header: 'Header' as AuthLocation,
  Query: 'Query' as AuthLocation,
  Cookie: 'Cookie' as AuthLocation,
};
